export const GUEST_LIKED_PRODUCTS_STORAGE_KEY = 'GUEST_LIKED_PRODUCTS';

export const GUEST_LIKED_PRODUCTS_STORAGE_LIMIT = 3;

export const GUEST_LIKES_TOAST_TIMEOUT = 4000;
